import { render } from "./Courier.vue?vue&type=template&id=54d6631f"
import script from "./Courier.vue?vue&type=script&lang=js"
export * from "./Courier.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__